import { AuthFetchWithResponse } from 'src/Types/api'
import { WallboxHardwareDto } from 'src/Libs/wallboxes/dto/wallbox-hardware.dto'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { StatusCodes } from 'src/Libs/http-status-codes'

const EDISON_WALL_BOX_TYPE = '5'

/**
 * Fetches wallboxes of a storage and decides if it has a connected bidi wallbox
 */
export const isBiDiWallboxConnected = async (
  serialNumber: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<WallboxHardwareDto>({
      path: `wallboxes/${serialNumber}`,
      method: 'GET',
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<boolean, AuthFetchError | Error>(null, true)
    }

    return new ApiResult<boolean, AuthFetchError | Error>(
      response.data.wbType.some(e => e.toString() === EDISON_WALL_BOX_TYPE),
      false
    )
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
